<template>
  <dv-scroll-board class="scroll-board" :config="config" />
</template>

<script>
import { getVirtualImitationOperateDateView } from "@/api/comd.js";
export default {
  data() {
    return {
      config: {
        header: ["虚仿分类", "操作用户", "实训虚仿项目", "实训时间"],
        data: [],
        oddRowBGC: "#0000",
        evenRowBGC: "#0000",
        headerBGC: "#2683d9b6",
        carousel: "single",
        columnWidth: [140, 140, 180, 200],
      },
      dataview: [],
    };
  },
  created() {
    this.getVirtualImitationOperateDateViewHandel();
  },
  methods: {
    getColor(index) {
      var colorArr = [
        "#414DE6",
        "#2391FF",
        "#0ABAFF",
        "#19DAFC",
        "#5AD8A6",
        "#07E8AE",
        "#2EFFD0",
        "#05FF84",
        "#931266",
        "#F84466",
        "#F7517F",
        "#EB7375",
        "#F45D41",
        "#FF745A",
        "#FFC328",
        "#FFDF25",
        "#6912F4",
        "#8922EC",
        "#9F3DF2",
        "#AF6AF7",
        "#E47FC8",
        "#D397C2",
        "#F8DC8F",
        "#E7E3B7",
        "#6490F2",
        "#6DC8EC",
        "#00A8BD",
        "#5D7092",
        "#0677D5",
        "#F79708",
        "#1E9493",
      ];
      return colorArr[index];
    },
    async getVirtualImitationOperateDateViewHandel() {
      let res = await getVirtualImitationOperateDateView();
      let aData=res.data.splice(0,200)
      debugger
      let i = 0;
      this.dataview = aData.map((en) => {
        let col = this.getColor(i);
        i++;
        return [
          `<span style="color:${col} ;font-size: 20px;">●</span> ${en.categoryName}`,
          `${en.userName}`,
          `${en.name}`,
          `${en.date}`,
        ];
      });
      this.config = {
        header: ["虚仿分类", "操作用户", "实训虚仿项目", "实训时间"],
        data: this.dataview,
        oddRowBGC: "#0000",
        evenRowBGC: "#0000",
        headerBGC: "#2683d9b6",
        carousel: "single",
        columnWidth: [140, 140, 180, 200],
      };
    },
  },
};
</script>

<style scoped>
.scroll-board {
  width: 600px;
  height: 250px;
  margin: 0 auto;
  margin-top: 20px;
  font-size: 14px;
}
</style>

<style>
.scroll-board .rows .row-item {
  border-bottom: 1px solid rgba(136, 190, 240, 0.212) !important;
}
.dv-scroll-board .rows {
  padding-bottom: 10px;
}
</style>